function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  y1: 0.5,
  x2: 1,
  y2: 0.5,
  gradientUnits: "objectBoundingBox"
}, React.createElement("stop", {
  offset: 0.014,
  stopColor: "#ff0054"
}), React.createElement("stop", {
  offset: 0.668,
  stopColor: "#e95c05"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#ffbd00"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_206",
  "data-name": "Group 206",
  transform: "translate(-42.743 -25)"
}, React.createElement("g", {
  id: "Layer_1",
  "data-name": "Layer 1",
  transform: "translate(42.743 25)"
}, React.createElement("path", {
  id: "Path_405",
  "data-name": "Path 405",
  d: "M80.787,101.087a38.044,38.044,0,1,1,26.9-64.946L101.5,42.326a29.3,29.3,0,1,0,0,41.436l6.184,6.184A37.8,37.8,0,0,1,80.787,101.087Z",
  transform: "translate(-42.743 -25)",
  fill: "url(#linear-gradient)"
})), React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(56.737 38.618)"
}, React.createElement("path", {
  id: "Path_406",
  "data-name": "Path 406",
  d: "M291.289,211.869l-2.108-2.156a1.249,1.249,0,0,0-1.7-.074l-.052.048-18.589,16.044-16.792,14.487-11.439-11.089a1.24,1.24,0,0,0-1.845.136l-6.332,8.243a1.233,1.233,0,0,0,.1,1.622l18.584,18.755a1.239,1.239,0,0,0,.879.372h.039a1.271,1.271,0,0,0,.905-.42l22.3-25.708,16.088-18.545.022-.026A1.246,1.246,0,0,0,291.289,211.869Z",
  transform: "translate(-232.178 -209.342)",
  fill: "url(#linear-gradient)"
})));

var SvgGroup1 = function SvgGroup1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 73.466,
    height: 76.087,
    viewBox: "0 0 73.466 76.087",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGroup1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Group 1.2ce45a29.svg";
export { ForwardRef as ReactComponent };